import { Device } from '../helpers/Device'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'
import { WindowSize } from '../helpers'
import { ExperimentFlag } from '../enums/ExperimentFlag'

export const MOBILE_ADUNIT_ID = 'feed_mobile'
export const DESKTOP_ADUNIT_ID = 'feed_btf'

export class Feed extends Slot {
  lazy = true
  slotName = 'feed'
  static experimentalOffset: number

  constructor(slot: ISlotModel, model: WebModel) {
    super(slot, model)
    this._sizes = this.adSizes
    this.adUnitId = Device.isMobileOrTablet
      ? MOBILE_ADUNIT_ID
      : DESKTOP_ADUNIT_ID

    // We want the experiment to be on a page-level, so we're using a Static property
    // on Content to store the experimentalValue, which is computed only once.
    if (Feed.experimentalOffset === undefined) {
      const offsetExperimentFlag = Device.isMobileOrTablet
        ? ExperimentFlag.feedMobileOffsetMultiplier
        : ExperimentFlag.feedBtfOffsetMultiplier

      Feed.experimentalOffset = parseFloat(
        model.experiment.activate(offsetExperimentFlag) as string
      )
    }

    // Experimental Timeouts
    if (Device.isMobileOrTablet) {
      // Lazy load all but first feed ad
      this.lazy = this.number > 1 ? true : false

      let experimentalTimeout
      if (this.lazy) {
        experimentalTimeout =
          parseFloat(
            this.model.experiment.activate(
              ExperimentFlag.feedMobileTimeout
            ) as string
          ) * 1000
      }

      if (experimentalTimeout) {
        // Only set targeting timeout value if it is part of the experiment.
        this.setTargeting({ timeout: experimentalTimeout })
      }

      this.timeout = experimentalTimeout || 1000
    }
  }

  get offset(): number {
    const mobileOffsetMultiplier = 4.6
    const desktopOffsetMultiplier = 3.4
    let offsetMultiplier = Device.isMobileOrTablet
      ? mobileOffsetMultiplier
      : desktopOffsetMultiplier

    // use experimentalOffset if it is truthy.
    if (Feed.experimentalOffset) {
      offsetMultiplier = Feed.experimentalOffset
      this.setTargeting({ offsetMultiplier })
    }

    return Math.floor(WindowSize.height * offsetMultiplier)
  }

  template(): string {
    const template = super.template()

    return Device.isMobileOrTablet
      ? `<div class='remove_padding'>
          ${template}
          </div>
      </div>`
      : template
  }

  private get adSizes(): AdSizes {
    const sizes: AdSizes = [
      [300, 250],
      'fluid',
      [336, 280],
      [468, 60],
      [728, 90],
      [250, 250]
    ]

    if (Device.isMobile) {
      sizes.push([320, 50], [300, 50], [320, 100])
    }

    return sizes
  }
}
